<template>
  <div class="teacher-floating">
    <!-- No floating components for now -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import sacService from "@/services/sac";

export default {
  name: "TeacherFloating",

  components: {},

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      currentClass: "getCurrentClass",
    }),

    isLecture() {
      return this.$route.name === "TeacherLecture";
    },

    hasClass() {
      return !!this.currentClass && !!this.currentClass.classId;
    },
  },

  watch: {},

  methods: {},

  mounted() {
    console.log("Teacher info", sacService.teacherInfo());
  },
};
</script>

<style scoped>
.floating-attendance-tracking {
  position: fixed;
  left: 0;
  bottom: 50px; /* Position above ClassSelect */
  z-index: 1000;
  width: 370px;
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.2),
    0 0 0 1px rgba(10, 10, 10, 0.02);
}

.floating-class-select {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1000;
  width: 370px;
}
</style>
